import React, { Component } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Menu from 'react-burger-menu/lib/menus/push'
import Headroom from 'react-headroom'


const Wrapper = styled.div`
  max-width: 1400px;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding-left: 40px;
    padding-right: 40px;
  }
`

const MenuWrapper = styled.div`
  &.light{
    #maurice-van-der-meijs-photography-logo-dark, #closeproject, #Desktop---Project{
      fill: white;
      color: white;
    }
    .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after, .is-active .hamburger-inner, .is-active .hamburger-inner::before, .is-active .hamburger-inner::after{
      background-color: white;
    }
  }
  &.light, &.dark{
    @media screen and (max-width: ${props => props.theme.responsive.medium}) {
      ${Wrapper}{
        justify-content: flex-end;
      }
    }
  }
`

const HeaderBar = styled(Headroom)`
  position: absolute;
  width: 100%;
  animation-duration: 1s;
  animation-delay: 0s;
  z-index: 999;
  .headroom {
    width: 100%;
    left: 0;
    right: 0;
    z-index: 2;
    top: 25px;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      top: 50px;
    }
  }
  .headroom--unfixed {
    position: fixed;
    transform: translateY(0);
    transition: transform 300ms ease-in-out;
  }
  .headroom--scrolled {
    transition: transform 300ms ease-in-out;
    &.headroom--pinned{
      transform: translateY(-75px);
      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        transform: translateY(-175%);
      }
    }
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-75px);
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      transform: translateY(-175%);
    }
  }
  .headroom--pinned {
    position: fixed;
    transition: transform 100ms ease-in-out;
  }

  #maurice-van-der-meijs-photography-logo-dark, #closeproject, #Desktop---Project{
    fill: black;
    color: black;
  }
`

const LogoLink = styled(Link)`
  display: inline-block;
  cursor: pointer;
  margin: 0;
  padding: 0;
  opacity: 1;
  transition: opacity .25s ease-in-out;
  &.hide{
    display: none;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      display: inline-block;
    }
  }
  &.menu-active{
    opacity: 0;
  }
`

const StyledBurgerMenu = styled.div`
  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: #222;
  }

  /* General sidebar styles */
  .bm-menu {
    background: #fff;
    padding: 1.5em 1.5em 0;
    font-size: 1.15em;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      padding: 2.5em 1.5em 0;
    }

  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list a {
    color: #222;
    padding: 0.8em;
    text-decoration: none;
    font-family: 'EDManteca', sans-serif;
  }

  .bm-item-list a::first-letter {
    font-size: 1.5em;
    font-family: 'EDMantecaBlack', sans-serif;
  }

  /* Individual item */
  .bm-item {
    display: inline-block;
    padding-bottom: 1em;
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
  }
  
`
const CloseProject = styled(Link)`
  display: none;
  padding: 0 0 40px 40px;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    padding: 15px 0;
  }
  cursor: pointer;
  text-decoration: none;
  color: black;
  font-weight: 300;

  &.show {
    display: inline-block;
  }
  span{
    display: none;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      display: inline;
    }
  }
`

const Close = ({ className, fill }) => (
  <svg className={className} width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Maurice van de Meijs - Close Button</title>
      <g id="Desktop-view" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Desktop---Project" transform="translate(-1214.000000, -81.000000)">
              <g id="Group-7" transform="translate(1214.000000, 75.000000)">
                  <g id="Group-5" transform="translate(0.000000, 6.000000)">
                      <rect id="Rectangle" transform="translate(7.651189, 7.467859) rotate(-45.000000) translate(-7.651189, -7.467859) " x="6.0148252" y="-1.03214122" width="3.27272727" height="17"></rect>
                      <polygon id="Rectangle" transform="translate(7.703227, 7.584179) rotate(-315.000000) translate(-7.703227, -7.584179) " points="6.08417938 -1.00672971 9.32227462 -1.00672971 9.32227462 16.1750885 6.08417938 16.1750885"></polygon>
                  </g>
              </g>
          </g>
      </g>
  </svg>
);

const StyledClose = styled(Close)`
  margin: 0 3px 0 0;
  width: 15px;
  display: inline;
`

const Hamburger = styled.div`
  padding: 15px 0 15px 15px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  align-self: center;
  z-index: 1001;
  transition: all 0.5s ease 0s;
  &.is-active {
    transform: translate3d(-300px, 0px, 0px);
  }

  &.hidden {
    display: none;
  }

  &:hover {
    opacity: 0.7;
  }
  &.is-active:hover {
    opacity: 0.7;
  }
  &.is-active .hamburger-inner,
  &.is-active .hamburger-inner::before,
  &.is-active .hamburger-inner::after {
    background-color: ${props => props.fill};
  }

  .hamburger-box {
    width: 40px;
    height: 24px;
    display: inline-block;
    position: relative;
  }

  .hamburger-inner {
    display: block;
    top: 50%;
    margin-top: -2px;
  }
  .hamburger-inner,
  .hamburger-inner::before,
  .hamburger-inner::after {
    width: 40px;
    height: 4px;
    background-color: ${props => props.fill};
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  .hamburger-inner::before,
  .hamburger-inner::after {
    content: '';
    display: block;
  }
  .hamburger-inner::before {
    top: -10px;
  }
  .hamburger-inner::after {
    bottom: -10px;
  }
  &.hamburger--slider .hamburger-inner {
    top: 2px;
  }
  &.hamburger--slider .hamburger-inner::before {
    top: 10px;
    transition-property: transform, opacity;
    transition-timing-function: ease;
    transition-duration: 0.15s;
  }
  &.hamburger--slider .hamburger-inner::after {
    top: 20px;
  }
  &.hamburger--slider.is-active .hamburger-inner {
    transform: translate3d(0, 10px, 0) rotate(45deg);
  }
  &.hamburger--slider.is-active .hamburger-inner::before {
    transform: rotate(-45deg) translate3d(-5.71429px, -6px, 0);
    opacity: 0;
  }
  &.hamburger--slider.is-active .hamburger-inner::after {
    transform: translate3d(0, -20px, 0) rotate(-90deg);
  }
`

const Logo = ({ className, fill }) => (
  <svg className={className} width="402" height="282" viewBox="0 0 402 282" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Maurice van de Meijs - Logo</title>
    <path d="M41.5 40.4C47.2 41 52.4 42.1 57.1 43.7C61.8 45.3 67 47.1 72.6 49.1C78.2 51.1 83 52.1 87 52.1C91.2 52.2 96 51 101.3 48.5C106.7 46 113 41.9 120.3 36.2C127.6 30.5 133.2 26 137.2 22.5C141.2 19 147.3 13.6 155.6 6.2L152.1 3.2C145.2 8.9 138.7 12.6 132.7 14.4C126.7 16.2 121.1 16.4 116.1 15C111.1 13.6 106.4 11.9 102.1 9.7C97.8 7.5 92.8 5.4 87 3.2C81.3 0.999997 75.7 0 70.2 0C64.7 0 64.4 0.500006 61.3 1.60001C58.2 2.60001 55.4 3.8 52.8 5C50.2 6.2 47.1 8.3 43.5 11.2C39.9 14.1 37.1 16.4 34.9 18.2C32.7 20 29.7 23 25.6 27.1C21.6 31.2 18.8 34.2 17.1 36C15.4 37.8 12.5 41.1 8.2 45.8C3.9 50.6 1.2 53.6 0 55L2.59999 58.5C9.49999 51.6 16.3 46.7 22.9 43.8C29.5 40.9 35.6 39.8 41.3 40.4H41.5Z" fill={fill}/>
    <path d="M383.299 236.7C378.599 234.2 374.699 230 371.499 224.2C368.299 218.4 366.699 212.7 366.699 207.2V53.6004C366.699 45.7004 363.699 37.7004 357.599 29.7004C351.599 21.7004 344.199 15.2004 335.699 10.3004C327.099 5.4004 319.099 2.90039 311.699 2.90039C305.799 6.70039 297.999 11.9004 288.499 18.4004C278.899 24.9004 269.299 31.6004 259.399 38.5004C249.599 45.3004 243.899 49.3004 242.499 50.3004C241.599 42.8004 238.199 35.3004 232.099 27.8004C226.099 20.3004 218.899 14.3004 210.599 9.8004C202.299 5.2004 194.599 3.0004 187.499 3.0004C180.799 7.3004 171.899 13.3004 160.599 21.0004C149.299 28.7004 138.999 35.8004 129.799 42.3004C120.499 48.8004 115.799 52.1004 115.499 52.2004C111.399 55.2004 108.199 57.5004 105.899 59.1004C103.599 60.8004 100.099 63.5004 95.4992 67.4004C90.8992 71.3004 87.3992 74.7004 84.7992 77.8004C82.1992 80.8004 79.7992 84.3004 77.6992 88.4004C75.4992 92.4004 74.4992 96.1004 74.4992 99.6004V113.7C69.0992 112.2 63.8992 112.8 58.9992 115.6C55.3992 117.9 51.9992 120.4 48.5992 122.9C45.2992 125.4 41.7992 128.3 38.0992 131.4C34.4992 134.5 31.5992 137.1 29.4992 139C27.3992 140.9 24.1992 143.9 19.8992 148C15.5992 152.1 12.6992 154.8 11.1992 156.1L14.2992 160.4C31.6992 146.1 51.6992 148.7 74.4992 168.4C74.4992 184.8 73.4992 196.8 71.3992 204.4C69.2992 212 64.0992 218.7 55.6992 224.5L58.2992 228.2C66.6992 223.9 73.9992 219.7 80.2992 215.8C86.5992 211.9 93.2992 206.9 100.599 201.1C107.799 195.2 113.399 188.8 117.399 181.9C121.299 174.9 123.299 167.7 123.299 160.2V66.2004C123.699 63.0004 124.499 60.6004 125.799 59.0004C127.099 57.4004 128.899 56.1004 131.299 55.1004C136.399 52.6004 141.999 51.4004 148.299 51.4004V209.1C148.299 215.8 147.699 221.2 146.399 225.4C145.199 229.6 143.399 232.5 140.999 234.1C138.699 235.7 135.999 236.6 133.099 236.9C130.199 237.1 126.699 236.9 122.699 235.9C118.699 235 114.799 233.9 110.999 232.7C107.199 231.5 102.899 230.3 97.9992 229.2C93.0992 228.1 88.6992 227.5 84.7992 227.3C74.6992 226.9 62.8992 232.5 49.3992 244.1C42.4992 250 31.3992 261.4 16.0992 278.2L18.2992 281.5C24.9992 275 31.5992 270.5 38.1992 268.2C44.7992 265.9 50.9992 265.3 56.6992 266.4C62.3992 267.6 67.7992 269.3 72.7992 271.5C77.7992 273.7 83.1992 275.9 88.9992 278.2C94.7992 280.4 99.8992 281.5 104.399 281.5C112.999 281.5 120.799 279.4 127.599 275.2C134.399 271 139.899 265.4 144.099 258.4C148.199 251.4 151.399 243.7 153.499 235.3C155.699 226.8 156.699 218.1 156.699 209.1V171.9C169.299 165.9 181.699 165.6 193.899 171.2V245.1C193.899 254.6 197.799 263.1 205.699 270.5C213.499 277.9 222.899 281.6 233.699 281.6L277.599 241.8V172C290.899 165.2 304.299 165.5 317.799 172.7V245.1C317.799 254.7 321.599 263.2 329.199 270.6C336.799 277.9 346.299 281.6 357.599 281.6L401.699 240L398.599 236.5C393.199 239.6 388.099 239.9 383.399 237.3L383.299 236.7ZM193.999 161.3C181.499 156.6 169.099 156.9 156.799 162V136.3C163.599 139 169.999 140.4 175.999 140.4C181.999 140.4 187.899 139.3 193.999 137.1V161.3ZM193.999 127.6C181.899 133.2 169.499 132.8 156.799 126.7V51.7004C166.399 53.3004 174.999 57.1004 182.599 63.2004C190.199 69.2004 193.999 75.0004 193.999 80.6004V127.6ZM250.099 227.7C245.299 221.8 242.899 215 242.899 207.2V58.9004C251.899 52.1004 260.699 47.9004 269.399 46.3004V236.6C261.399 236.5 254.999 233.5 250.199 227.6L250.099 227.7ZM317.799 162.4C304.099 156.5 290.699 156.4 277.599 162V136.3C284.399 139 290.699 140.4 296.699 140.4C302.699 140.4 310.399 138.8 317.799 135.6V162.4ZM317.799 126C303.999 133.3 290.599 133.5 277.599 126.7V45.3004C289.099 45.2004 298.599 48.9004 306.299 56.4004C313.899 63.9004 317.799 72.0004 317.799 80.6004V125.9V126Z" fill={fill}/>
  </svg>
);

const StyledLogo = styled(Logo)`
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  margin: 0;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 0 75px;
    width: 75px;
    height: 75px;
  }
`

class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
      dark: true
    }
  }

  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen })
  }

  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu() {
    this.setState({ menuOpen: false })
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  fillColor = () => {
    if (typeof window === 'undefined') {
      return 'white'
    }
    const path = window.location.pathname
    const isResponsive = window.innerWidth < 768

    // About, Contact, Work pages, or homepage responsive = blue
    if (path === '/about' || path === '/about/' ||
        path === '/contact' || path === '/contact/' ||
        path === '/work' || path === '/work/' ||
        (path === '/' && isResponsive)) {
      return '#1510F8'
    }
    return 'white'
  }
  
  render() {
    return (
      <MenuWrapper id="menu" style={{
        opacity: this.props.hidden ? 0 : 1,
        pointerEvents: this.props.hidden ? 'none' : 'auto',
        transition: 'opacity 0.5s ease-in-out'
      }}>
        <StyledBurgerMenu>
          <Menu
            right
            pageWrapId={this.props.pageWrapId}
            outerContainerId={this.props.outerContainerId}
            isOpen={this.state.menuOpen}
            onStateChange={state => this.handleStateChange(state)}
            customBurgerIcon={false}
            customCrossIcon={false}
          >
            <Link to="/" alt="Home">
              Home.
            </Link>
            <Link to="/work" alt="Work">
              Work.
            </Link>
            <Link to="/about" alt="About">
              About.
            </Link>
            <Link to="/contact" alt="Contact">
              Contact.
            </Link>
          </Menu>
        </StyledBurgerMenu>
        <HeaderBar
          disableInlineStyles
        >
          <Wrapper>
            <LogoLink to="/" id="logo" className={
                this.state.menuOpen
                  ? 'menu-active'
                  : ''
              }>
              <StyledLogo fill={this.fillColor()} />      
            </LogoLink>
            <Hamburger
              id="hamburger"
              fill={this.fillColor()}
              onClick={() => this.toggleMenu()}
              className={
                this.state.menuOpen
                  ? 'hamburger hamburger--slider is-active'
                  : 'hamburger hamburger--slider'
              }
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </Hamburger>
            <CloseProject to="/" id="closeproject" fill={this.fillColor()}>
              <StyledClose fill={this.fillColor()} /><span> Close</span> 
            </CloseProject>
          </Wrapper>
        </HeaderBar>
      </MenuWrapper>
    )
  }
}

export default Navigation
